import React from "react"
import {
  ArrowForward
} from "@mui/icons-material"
import { TopBarRedesigned } from "components/TopBarRedesigned"
import { useHistory } from 'react-router'
import { exitReact } from "utils"
import { Button, Box } from "@mui/material"
import MaterialInput from "components/Inputs/MaterialInput"
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  BluePaper,
  InfoPaper,
  SectionTitle,
  GuideLink,
  InfoTitle,
  InfoText,
} from './SecondStep.styles'

export interface SecondStepProps {
    titleValue?: string;
    titleValueError?: string;
    onTitleValueChange: (value: string) => void
    descriptionValue?: string;
    descriptionValueError?: string;
    onDescriptionValueChange: (value: string) => void
    practiceName?: string
    onBack: () => void
    onClose: () => void
    onSubmit: (event: React.FormEvent) => void
}

const SecondStep: React.FC<SecondStepProps> = ({
    titleValue,
    titleValueError,
    onTitleValueChange,
    descriptionValue,
    descriptionValueError,
    onDescriptionValueChange,
    practiceName,
    onBack,
    onClose,
    onSubmit
}) => {
  const history = useHistory();
  
  return (
    <>
      <TopBarRedesigned
        onBack={() => {
          history.push('loading')
          exitReact('home')
        }}
      />
      <MainContainer>
        <ContentContainer>
          <PageTitle variant="h5">
            Post a Permanent / Contract Position
          </PageTitle>
          
          <BluePaper elevation={1}>
            <InfoTitle variant="h6" sx={{ mb: 2 }}>
              Ok, {practiceName ? practiceName : ""} - let's get a Title and Description written!
            </InfoTitle>
            <InfoText variant="body1" sx={{ mb: 2 }}>
              Write at least 15 words to describe the position. Include key details about the role, 
              highlight important qualifications, and explain why applicants should be interested in 
              applying to your practice.
            </InfoText>
            <GuideLink 
              href="https://support.tempstars.com/hc/en-us/articles/31049914906899-How-to-Attract-Top-Talent-with-your-Job-Description-for-Dental-Offices" 
              target="_blank"
              rel="noopener noreferrer"
              className="external"
            >
              Guide to Writing Great Job Posts
            </GuideLink>
          </BluePaper>
            
          <SectionTitle variant="subtitle1" gutterBottom>
            Job Title
          </SectionTitle>
          <Box sx={{ mb: 4 }}>
            <MaterialInput
              id="title"
              name="title"
              value={titleValue || ''}
              onChange={(e) => onTitleValueChange(e.target.value)}
              error={!!titleValueError}
              helperText={titleValueError}
              label="Enter job title"
            />
          </Box>
            
          <SectionTitle variant="subtitle1" gutterBottom>
            Job Description
          </SectionTitle>
          <Box sx={{ mb: 4 }}>
            <MaterialInput
              id="description"
              name="description"
              value={descriptionValue || ''}
              onChange={(e) => onDescriptionValueChange(e.target.value)}
              error={!!descriptionValueError}
              helperText={descriptionValueError}
              label="Enter job description"
              multiline={true}
              rows={7}
            />
          </Box>
          
          <InfoPaper elevation={1}>
            <InfoTitle variant="subtitle1" gutterBottom>
              Note:
            </InfoTitle>
            <InfoText variant="body2">
              After submission, we'll automatically check for spelling and grammar
              issues, and suggest improvements to your job posting.
            </InfoText>
            <InfoText variant="body2">
              We'll provide an enhanced version of your description that you can
              choose to use if you prefer it. Both versions will be shown for you to compare.
            </InfoText>
            <InfoText variant="body2" sx={{ mb: 0 }}>
              You can review applications and contact candidates free of charge - only
              permanent hires will incur any fees.
            </InfoText>
          </InfoPaper>
            
          <Button
            variant="contained"
            endIcon={<ArrowForward />}
            onClick={onSubmit}
            fullWidth
            sx={{
              bgcolor: "var(--primary-blue)",
              borderRadius: 10,
              py: 1.5,
              textTransform: "uppercase",
              fontWeight: "bold",
              boxShadow: 2,
              mt: 4,
              '&:hover': {
                bgcolor: "#002266",
              },
            }}
          >
            Continue
          </Button>
        </ContentContainer>
      </MainContainer>
    </>
  )
}

export default SecondStep;
